import { c as _c } from "react/compiler-runtime";
import React, { type ReactElement, type ReactNode } from 'react';
import { StyledInput, StyledLabel, StyledMessage, StyledClearButton } from './styles';
import { type InputType, type InputProps, getBadgeColor } from './types';
import Badge from '../Badge';
import { CancelBkgIcon as CancelBkg } from '../icons/CancelBkgIcon';
import { IconButton, InputAdornment } from '@mui/material';
import Grid from '../Grid';
const RightIcon = t0 => {
  const $ = _c(5);
  const {
    onClick,
    children
  } = t0;
  if (onClick != null) {
    let t1;
    if ($[0] !== children || $[1] !== onClick) {
      t1 = <InputAdornment position="end"><IconButton onClick={onClick}>{children}</IconButton></InputAdornment>;
      $[0] = children;
      $[1] = onClick;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] !== children) {
    t1 = <InputAdornment position="end">{children}</InputAdornment>;
    $[3] = children;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
const LeftIcon = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Grid width="24px" height="24px">{children}</Grid>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const TYPE_INPUT_MODE_MAP: Record<InputType, 'text' | 'numeric'> = {
  text: 'text',
  number: 'numeric'
};
const NUMERIC_INPUT_PATTERN = '[0-9]*';
const PASSWORD_INPUT_TYPE = 'password' as const; // NOSONAR(S2068)

const Input = React.forwardRef<HTMLInputElement, InputProps>((t0, ref) => {
  const $ = _c(86);
  let InputProps;
  let clearInput;
  let color;
  let helperText;
  let inputProps;
  let minRows;
  let multiline;
  let name;
  let onBlur;
  let onChange;
  let onFocus;
  let onRightIconClick;
  let props;
  let rightIcon;
  let rows;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let value;
  if ($[0] !== t0) {
    ({
      name,
      value,
      disabled: t1,
      onChange,
      onBlur,
      onRightIconClick,
      color,
      helperText,
      placeholder: t2,
      assistive: t3,
      clearInput,
      fullWidth: t4,
      rightIcon,
      multiline,
      minRows,
      maxRows: t5,
      rows,
      type: t6,
      onFocus,
      inputProps,
      InputProps,
      autoFocus: t7,
      isPassword: t8,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = InputProps;
    $[2] = clearInput;
    $[3] = color;
    $[4] = helperText;
    $[5] = inputProps;
    $[6] = minRows;
    $[7] = multiline;
    $[8] = name;
    $[9] = onBlur;
    $[10] = onChange;
    $[11] = onFocus;
    $[12] = onRightIconClick;
    $[13] = props;
    $[14] = rightIcon;
    $[15] = rows;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = value;
  } else {
    InputProps = $[1];
    clearInput = $[2];
    color = $[3];
    helperText = $[4];
    inputProps = $[5];
    minRows = $[6];
    multiline = $[7];
    name = $[8];
    onBlur = $[9];
    onChange = $[10];
    onFocus = $[11];
    onRightIconClick = $[12];
    props = $[13];
    rightIcon = $[14];
    rows = $[15];
    t1 = $[16];
    t2 = $[17];
    t3 = $[18];
    t4 = $[19];
    t5 = $[20];
    t6 = $[21];
    t7 = $[22];
    t8 = $[23];
    value = $[24];
  }
  const disabled = t1 === undefined ? false : t1;
  const placeholder = t2 === undefined ? "" : t2;
  const assistive = t3 === undefined ? false : t3;
  const fullWidth = t4 === undefined ? false : t4;
  const maxRows = t5 === undefined ? 3 : t5;
  const type = t6 === undefined ? "text" : t6;
  const autoFocus = t7 === undefined ? false : t7;
  const isPassword = t8 === undefined ? false : t8;
  let t9;
  if ($[25] !== props.labelText) {
    t9 = props.labelText != null && <StyledLabel>{props.labelText}</StyledLabel>;
    $[25] = props.labelText;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  const t10 = onRightIconClick != null;
  const t11 = props.icon != null;
  let t12;
  if ($[27] !== props.fontSizeVariant) {
    t12 = props.fontSizeVariant != null && {
      $fontSizeVariant: props.fontSizeVariant
    };
    $[27] = props.fontSizeVariant;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== props.backgroundColor) {
    t13 = props.backgroundColor != null && {
      $backgroundColor: props.backgroundColor
    };
    $[29] = props.backgroundColor;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== props.icon) {
    t14 = props.icon != null && <LeftIcon>{props.icon}</LeftIcon>;
    $[31] = props.icon;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== clearInput || $[34] !== disabled || $[35] !== onRightIconClick || $[36] !== rightIcon) {
    t15 = clearInput != null ? <InputAdornment position="end"><StyledClearButton onClick={clearInput} disabled={disabled}><CancelBkg /></StyledClearButton></InputAdornment> : rightIcon != null ? <RightIcon onClick={onRightIconClick}>{rightIcon}</RightIcon> : undefined;
    $[33] = clearInput;
    $[34] = disabled;
    $[35] = onRightIconClick;
    $[36] = rightIcon;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== InputProps || $[39] !== t14 || $[40] !== t15) {
    t16 = {
      startAdornment: t14,
      endAdornment: t15,
      ...InputProps
    };
    $[38] = InputProps;
    $[39] = t14;
    $[40] = t15;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  const t17 = TYPE_INPUT_MODE_MAP[type];
  let t18;
  if ($[42] !== type) {
    t18 = type === "number" && {
      pattern: NUMERIC_INPUT_PATTERN
    };
    $[42] = type;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== inputProps || $[45] !== t17 || $[46] !== t18) {
    t19 = {
      inputMode: t17,
      ...t18,
      ...inputProps
    };
    $[44] = inputProps;
    $[45] = t17;
    $[46] = t18;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  const t20 = rightIcon != null || clearInput != null;
  let t21;
  if ($[48] !== isPassword) {
    t21 = isPassword && {
      type: PASSWORD_INPUT_TYPE
    };
    $[48] = isPassword;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== assistive || $[51] !== autoFocus || $[52] !== color || $[53] !== disabled || $[54] !== fullWidth || $[55] !== maxRows || $[56] !== minRows || $[57] !== multiline || $[58] !== name || $[59] !== onBlur || $[60] !== onChange || $[61] !== onFocus || $[62] !== placeholder || $[63] !== props.className || $[64] !== props.id || $[65] !== props.onClick || $[66] !== props.onKeyDown || $[67] !== ref || $[68] !== rows || $[69] !== t10 || $[70] !== t11 || $[71] !== t12 || $[72] !== t13 || $[73] !== t16 || $[74] !== t19 || $[75] !== t20 || $[76] !== t21 || $[77] !== value) {
    t22 = <StyledInput $assistive={assistive} className={props.className} id={props.id} name={name} ref={ref} placeholder={placeholder} value={value} onChange={onChange} onBlur={onBlur} onKeyDown={props.onKeyDown} color={color} disabled={disabled} autoFocus={autoFocus} fullWidth={fullWidth} $isRightIconClickable={t10} multiline={multiline} minRows={minRows} maxRows={maxRows} rows={rows} onFocus={onFocus} $hasLeftIcon={t11} {...t12} {...t13} InputProps={t16} onClick={props.onClick} inputProps={t19} $hasRightIcon={t20} {...t21} />;
    $[50] = assistive;
    $[51] = autoFocus;
    $[52] = color;
    $[53] = disabled;
    $[54] = fullWidth;
    $[55] = maxRows;
    $[56] = minRows;
    $[57] = multiline;
    $[58] = name;
    $[59] = onBlur;
    $[60] = onChange;
    $[61] = onFocus;
    $[62] = placeholder;
    $[63] = props.className;
    $[64] = props.id;
    $[65] = props.onClick;
    $[66] = props.onKeyDown;
    $[67] = ref;
    $[68] = rows;
    $[69] = t10;
    $[70] = t11;
    $[71] = t12;
    $[72] = t13;
    $[73] = t16;
    $[74] = t19;
    $[75] = t20;
    $[76] = t21;
    $[77] = value;
    $[78] = t22;
  } else {
    t22 = $[78];
  }
  let t23;
  if ($[79] !== color || $[80] !== helperText) {
    t23 = helperText != null && <StyledMessage><Badge color={getBadgeColor(color)} /><span>{helperText}</span></StyledMessage>;
    $[79] = color;
    $[80] = helperText;
    $[81] = t23;
  } else {
    t23 = $[81];
  }
  let t24;
  if ($[82] !== t22 || $[83] !== t23 || $[84] !== t9) {
    t24 = <>{t9}{t22}{t23}</>;
    $[82] = t22;
    $[83] = t23;
    $[84] = t9;
    $[85] = t24;
  } else {
    t24 = $[85];
  }
  return t24;
});
export default Input;
export { Input };
export type { InputProps } from './types';